// extracted by mini-css-extract-plugin
export default {"landingContainer":"HomeView-styles__landingContainer__srxQ1","sideNavContainer":"HomeView-styles__sideNavContainer__wOnI3"};